import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { NavigationHelperContext } from './NavigationHelperContext';

export const NavigationHelperProvider = ({ children }) => {
    const [currentScreen, setCurrentScreen] = useState('');
    const prevScreen = useRef('');

    const setNewCurrentScreen = (newCurrentScreen) => {
        if (currentScreen !== prevScreen) prevScreen.current = currentScreen;
        setCurrentScreen(newCurrentScreen);
    };

    return (
        <NavigationHelperContext.Provider
            value={{
                prevScreen: prevScreen.current,
                currentScreen,
                setCurrentScreen: setNewCurrentScreen
            }}
        >
            {children}
        </NavigationHelperContext.Provider>
    );
};

NavigationHelperProvider.defaultProps = {
    children: []
};

NavigationHelperProvider.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
